export default {
    "name": "GetGetYourGuideTours",
    "kind": "HoudiniQuery",
    "hash": "1ec14abefd12b72e8927452014c6df5fb9a457354cad1d366418fa525b84bbab",

    "raw": `query GetGetYourGuideTours($lat: Float!, $lng: Float!) {
  getGetYourGuideTours(input: {coordinates: {lat: $lat, lng: $lng}, limit: 3}) {
    ... on SearchGetYourGuideToursFound {
      __typename
      tours {
        bookUrl
        imageUrl
        price {
          amount
          currency
        }
        review {
          count
          mention
          score
        }
        title
        tourId
      }
    }
    ... on SearchGetYourGuideToursNotFound {
      __typename
      message
    }
    ... on SearchGetYourGuideToursNotFoundWithRegionData {
      __typename
      url
    }
    ... on SearchGetYourGuideToursNotFoundWithoutRegionData {
      __typename
      url
    }
    __typename
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getGetYourGuideTours": {
                "type": "SearchGetYourGuideToursResult",
                "keyRaw": "getGetYourGuideTours(input: {coordinates: {lat: $lat, lng: $lng}, limit: 3})",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "SearchGetYourGuideToursFound": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "tours": {
                                    "type": "Tour",
                                    "keyRaw": "tours",

                                    "selection": {
                                        "fields": {
                                            "bookUrl": {
                                                "type": "String",
                                                "keyRaw": "bookUrl",
                                                "visible": true
                                            },

                                            "imageUrl": {
                                                "type": "String",
                                                "keyRaw": "imageUrl",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "price": {
                                                "type": "Price",
                                                "keyRaw": "price",

                                                "selection": {
                                                    "fields": {
                                                        "amount": {
                                                            "type": "Float",
                                                            "keyRaw": "amount",
                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "review": {
                                                "type": "Review",
                                                "keyRaw": "review",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "count": {
                                                            "type": "Int",
                                                            "keyRaw": "count",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "mention": {
                                                            "type": "REVIEW_MENTION",
                                                            "keyRaw": "mention",
                                                            "visible": true
                                                        },

                                                        "score": {
                                                            "type": "Float",
                                                            "keyRaw": "score",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "visible": true
                                            },

                                            "tourId": {
                                                "type": "Int",
                                                "keyRaw": "tourId",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                }
                            },

                            "SearchGetYourGuideToursNotFound": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                }
                            },

                            "SearchGetYourGuideToursNotFoundWithRegionData": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "url": {
                                    "type": "String",
                                    "keyRaw": "url",
                                    "visible": true
                                }
                            },

                            "SearchGetYourGuideToursNotFoundWithoutRegionData": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "url": {
                                    "type": "String",
                                    "keyRaw": "url",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "lat": "Float",
            "lng": "Float"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=6557e617dfd83991fd099ab4ef1d184c83ce4c706207f4221a6751faa0bde1d0";